<template>
<div class="chapter">
<div class="inner_page">
<div class="book" title="You've Totally Got This!"><div class="frontmatter"><div class="recto"><h1 class="title"><a id="index">You've Totally Got This!</a></h1><h4><a id="index">Illustrations by Francis Macleod</a></h4><a id="index"><img alt="Gibbs Smith Logo" src="images/logo.jpg"/></a></div><div class="verso"><p class="versotitle"><a id="index">You've Totally Got This!</a></p><p><a id="index">Digital Edition 1.0</a></p><p class="copyright"><a id="index">Text © 2019 Gibbs Smith Publisher</a></p><p><a id="index">Illustrations © 2019 Francis Macleod</a></p><p><a id="index">All rights reserved. No part of this book may be reproduced by any means whatsoever without written permission from the publisher, except brief portions quoted for purpose of review.</a></p><p class="nobreak"><a id="index">Gibbs Smith</a></p><p class="nobreak"><a id="index">P.O. Box 667</a></p><p><a id="index">Layton, Utah 84041</a></p><p class="nobreak"><a id="index">Orders: 1.800.835.4993</a></p><p><a id="index">www.gibbs-smith.com</a></p><p><a id="index">ISBN: 9781423651222</a></p></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?ff878db0